import { addDays } from "./recurrence";

/** Data civil YYYY-MM-DD → dd/mm/aaaa (sem passar por Date: datas civis não têm fuso). */
export function formatDate(civil: string): string {
  const [y, m, d] = civil.split("-");
  return `${d}/${m}/${y}`;
}

/** "2026-03" → "março de 2026". */
export function formatMonth(month: string): string {
  const [y, m] = month.split("-").map(Number) as [number, number];
  return new Intl.DateTimeFormat("pt-BR", { month: "long", year: "numeric", timeZone: "UTC" }).format(
    Date.UTC(y, m - 1, 1),
  );
}

export function todayCivil(timeZone: string, now: Date = new Date()): string {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(now);
}

export function currentMonth(timeZone: string, now: Date = new Date()): string {
  return todayCivil(timeZone, now).slice(0, 7);
}

export function addMonths(month: string, delta: number): string {
  const [y, m] = month.split("-").map(Number) as [number, number];
  const total = y * 12 + (m - 1) + delta;
  return `${Math.floor(total / 12)}-${String((total % 12) + 1).padStart(2, "0")}`;
}

const SHORT_MONTHS = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];

/** "2026-01" → "jan/2026". */
export function shortMonth(month: string): string {
  const [y, m] = month.split("-").map(Number) as [number, number];
  return `${SHORT_MONTHS[m - 1]}/${y}`;
}

export const isMonth = (value: string) => /^\d{4}-(0[1-9]|1[0-2])$/.test(value);

export const WEEKDAYS = [
  "domingo",
  "segunda-feira",
  "terça-feira",
  "quarta-feira",
  "quinta-feira",
  "sexta-feira",
  "sábado",
];

const LONG = new Intl.DateTimeFormat("pt-BR", {
  weekday: "long",
  day: "numeric",
  month: "long",
  timeZone: "UTC",
});
const WITH_YEAR = new Intl.DateTimeFormat("pt-BR", {
  weekday: "long",
  day: "numeric",
  month: "long",
  year: "numeric",
  timeZone: "UTC",
});

/** "Hoje", "Ontem" ou "Terça, 10 de março" (com o ano quando não é o ano corrente). */
export function dayLabel(date: string, today: string): string {
  if (date === today) return "Hoje";
  if (date === addDays(today, -1)) return "Ontem";
  const [y, m, d] = date.split("-").map(Number) as [number, number, number];
  const fmt = y === Number(today.slice(0, 4)) ? LONG : WITH_YEAR;
  const s = fmt.format(Date.UTC(y, m - 1, d)).replace("-feira", "");
  return s.charAt(0).toUpperCase() + s.slice(1);
}

const WEEKDAY_SHORT = new Intl.DateTimeFormat("pt-BR", { weekday: "short", timeZone: "UTC" });
/** "2026-03-17" → "Ter, 17/03". */
export function shortDay(civil: string) {
  const [y, m, d] = civil.split("-").map(Number) as [number, number, number];
  const wd = WEEKDAY_SHORT.format(Date.UTC(y, m - 1, d)).replace(".", "");
  return `${wd.charAt(0).toUpperCase()}${wd.slice(1)}, ${String(d).padStart(2, "0")}/${String(m).padStart(2, "0")}`;
}
